import { useEffect } from "react";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";
import { useSocket } from "@/context/SocketContext";

// Shows a distinctive gold notification when someone super-admires you.
export default function SuperLikeToast() {
  const { addSuperLikeListener } = useSocket();
  useEffect(() => {
    const off = addSuperLikeListener((data) => {
      const u = data.user || {};
      toast.custom((t) => (
        <div data-testid="superlike-toast" className="flex items-center gap-4 px-5 py-4 rounded-2xl border border-gold/50 bg-surface shadow-2xl min-w-[300px]">
          <span className="w-11 h-11 rounded-full bg-gold/15 flex items-center justify-center shrink-0">
            <Sparkles size={20} className="text-gold" />
          </span>
          <div>
            <p className="text-xs uppercase tracking-[0.25em] text-gold">Super Admire ✦</p>
            <p className="text-sm mt-1"><span className="font-medium">{u.display_name || "Someone"}</span> super-admires you.</p>
          </div>
        </div>
      ), { duration: 6000 });
    });
    return off;
  }, [addSuperLikeListener]);
  return null;
}
